import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProvisioning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 42.93 44.76",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-2,.cls-3{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:0.88px;}.cls-2{stroke-width:0.77px;}.cls-3{stroke-width:2.89px;}.cls-4{opacity:0.5;isolation:isolate;}.cls-5{fill:#1d1d1b;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			"data-name": "Ebene 1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "M126.81,74.17l40.67.06-6,20.39-28.25.06-6.45-20.51Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "M147.43,72.81l-.06,21.31"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "m126.57 72.86l6 21.34"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "m137.2 72.79l2.85 21.46"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "m168.07 72.5-5.87 21.64"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					transform: "translate(-125.97 -50.62)",
					d: "m157.78 72.67l-3 21.68"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M139.62,93.95a16.86,16.86,0,0,0,4.15,1,16.86,16.86,0,0,0,4.15-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M147,93.95a16.86,16.86,0,0,0,4.15,1,16.86,16.86,0,0,0,4.15-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M154.45,93.95a16.86,16.86,0,0,0,4.15,1,16.86,16.86,0,0,0,4.15-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M132.2,93.95a16.86,16.86,0,0,0,4.15,1,16.86,16.86,0,0,0,4.15-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M143.22,93.3a22.71,22.71,0,0,0,4.27.78,22.72,22.72,0,0,0,4.27-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151,93.3a22.71,22.71,0,0,0,4.27.78,22.72,22.72,0,0,0,4.27-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M136.65,93.3a22.71,22.71,0,0,0,4.27.78,22.72,22.72,0,0,0,4.27-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M131.68,93.3a10.55,10.55,0,0,0,2.85.78,10.55,10.55,0,0,0,2.85-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M163.17,93.3a10.55,10.55,0,0,1-2.85.78,10.55,10.55,0,0,1-2.85-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M139.21,92.27a18.48,18.48,0,0,0,4.37,1,18.48,18.48,0,0,0,4.37-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M147,92.27a18.48,18.48,0,0,0,4.37,1,18.48,18.48,0,0,0,4.37-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M154.81,92.27a18.48,18.48,0,0,0,4.37,1,18.48,18.48,0,0,0,4.37-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M131.4,92.27a18.48,18.48,0,0,0,4.37,1,18.48,18.48,0,0,0,4.37-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M143.1,91.23a18.59,18.59,0,0,0,4.38,1,18.59,18.59,0,0,0,4.38-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151.13,91.23a18.59,18.59,0,0,0,4.38,1,18.59,18.59,0,0,0,4.38-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M136.37,91.23a18.59,18.59,0,0,0,4.38,1,18.59,18.59,0,0,0,4.38-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M131.27,91.23a9,9,0,0,0,2.92,1,9,9,0,0,0,2.92-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M163.58,91.23a9,9,0,0,1-2.92,1,9,9,0,0,1-2.92-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M139,90.18a19.44,19.44,0,0,0,4.49,1,19.44,19.44,0,0,0,4.49-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M147,90.18a19.44,19.44,0,0,0,4.49,1,19.44,19.44,0,0,0,4.49-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M155,90.18a19.44,19.44,0,0,0,4.49,1,19.44,19.44,0,0,0,4.49-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M130.95,90.18a19.44,19.44,0,0,0,4.49,1,19.44,19.44,0,0,0,4.49-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M142.85,88.72a20.67,20.67,0,0,0,4.65,1,20.67,20.67,0,0,0,4.65-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151.35,88.72a20.67,20.67,0,0,0,4.65,1,20.67,20.67,0,0,0,4.65-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M135.71,88.72a20.67,20.67,0,0,0,4.65,1,20.67,20.67,0,0,0,4.65-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M130.3,88.72a9.91,9.91,0,0,0,3.1,1,9.91,9.91,0,0,0,3.1-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M164.55,88.72a9.91,9.91,0,0,1-3.1,1,9.91,9.91,0,0,1-3.1-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M138.55,87.46a21.25,21.25,0,0,0,4.72,1,21.25,21.25,0,0,0,4.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M147,87.46a21.25,21.25,0,0,0,4.72,1,21.25,21.25,0,0,0,4.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M155.4,87.46a21.25,21.25,0,0,0,4.72,1,21.25,21.25,0,0,0,4.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M130.13,87.46a21.25,21.25,0,0,0,4.72,1,21.25,21.25,0,0,0,4.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M142.67,86a22.12,22.12,0,0,0,4.82,1,22.12,22.12,0,0,0,4.82-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151.49,86a22.12,22.12,0,0,0,4.82,1,22.12,22.12,0,0,0,4.82-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M135.27,86a22.12,22.12,0,0,0,4.82,1,22.12,22.12,0,0,0,4.82-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M129.66,86a10.54,10.54,0,0,0,3.21,1,10.54,10.54,0,0,0,3.21-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M165.19,86A10.54,10.54,0,0,1,162,87a10.54,10.54,0,0,1-3.21-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M138.15,84.74a23,23,0,0,0,4.93,1,23,23,0,0,0,4.93-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M147,84.74a23,23,0,0,0,4.93,1,23,23,0,0,0,4.93-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M155.75,84.74a23,23,0,0,0,4.93,1,23,23,0,0,0,4.93-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M129.36,84.74a23,23,0,0,0,4.93,1,23,23,0,0,0,4.93-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M142.5,83.28a23.63,23.63,0,0,0,5,1,23.63,23.63,0,0,0,5-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151.64,83.28a23.63,23.63,0,0,0,5,1,23.63,23.63,0,0,0,5-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M134.83,83.28a23.63,23.63,0,0,0,5,1,23.63,23.63,0,0,0,5-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M129,83.28a11.19,11.19,0,0,0,3.33,1,11.19,11.19,0,0,0,3.33-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M165.84,83.28a11.19,11.19,0,0,1-3.33,1,11.19,11.19,0,0,1-3.33-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M137.71,82a25.1,25.1,0,0,0,5.16,1A25.1,25.1,0,0,0,148,82"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M146.93,82a25.1,25.1,0,0,0,5.16,1,25.1,25.1,0,0,0,5.16-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M156.14,82a25.1,25.1,0,0,0,5.16,1,25.1,25.1,0,0,0,5.16-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M128.5,82a25.1,25.1,0,0,0,5.16,1,25.1,25.1,0,0,0,5.16-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M142.31,80.35a25.4,25.4,0,0,0,5.19,1,25.4,25.4,0,0,0,5.19-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M151.81,80.35a25.4,25.4,0,0,0,5.19,1,25.4,25.4,0,0,0,5.19-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M134.33,80.35a25.4,25.4,0,0,0,5.19,1,25.4,25.4,0,0,0,5.19-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M128.29,80.35a12,12,0,0,0,3.46,1,12,12,0,0,0,3.46-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M166.56,80.35a12,12,0,0,1-3.46,1,12,12,0,0,1-3.46-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M137.36,79.09a26.82,26.82,0,0,0,5.35,1,26.82,26.82,0,0,0,5.35-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M146.91,79.09a26.82,26.82,0,0,0,5.35,1,26.82,26.82,0,0,0,5.35-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M156.45,79.09a26.82,26.82,0,0,0,5.35,1,26.82,26.82,0,0,0,5.35-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M127.81,79.09a26.82,26.82,0,0,0,5.35,1,26.82,26.82,0,0,0,5.35-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M142,77.42a28.07,28.07,0,0,0,5.48,1,28.07,28.07,0,0,0,5.48-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M152,77.42a28.07,28.07,0,0,0,5.48,1,28.07,28.07,0,0,0,5.48-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M133.61,77.42a28.07,28.07,0,0,0,5.48,1,28.07,28.07,0,0,0,5.48-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M127.24,77.42a13.11,13.11,0,0,0,3.65,1,13.11,13.11,0,0,0,3.65-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M167.61,77.42a13.11,13.11,0,0,1-3.65,1,13.11,13.11,0,0,1-3.65-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M136.92,76.16a29.06,29.06,0,0,0,5.58,1,29.06,29.06,0,0,0,5.58-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M146.88,76.16a29.06,29.06,0,0,0,5.58,1,29.06,29.06,0,0,0,5.58-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M156.84,76.16a29.06,29.06,0,0,0,5.58,1,29.06,29.06,0,0,0,5.58-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M127,76.16a29.06,29.06,0,0,0,5.58,1,29.06,29.06,0,0,0,5.58-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M141.79,74.49a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M152.25,74.49a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M133,74.49a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M126.35,74.49a14.15,14.15,0,0,0,3.81,1,14.15,14.15,0,0,0,3.81-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M168.5,74.49a14.15,14.15,0,0,1-3.81,1,14.15,14.15,0,0,1-3.81-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M136.92,73.58a41.38,41.38,0,0,1,5.58-.71,41.38,41.38,0,0,1,5.58.71"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M146.88,73.58a41.38,41.38,0,0,1,5.58-.71,41.38,41.38,0,0,1,5.58.71"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M156.84,73.58a41.38,41.38,0,0,1,5.58-.71,41.38,41.38,0,0,1,5.58.71"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M127,73.58a41.38,41.38,0,0,1,5.58-.71,41.38,41.38,0,0,1,5.58.71"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M136.65,73.23a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M146.87,73.23a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M157.08,73.23a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					transform: "translate(-125.97 -50.62)",
					d: "M126.44,73.23a30.45,30.45,0,0,0,5.72,1,30.45,30.45,0,0,0,5.72-1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-3",
					transform: "translate(-125.97 -50.62)",
					d: "m128.28 74.36s-1.73-22.3 19.25-22.3 19 22.3 19 22.3"
				}),
				/* @__PURE__ */ _jsx("g", {
					className: "cls-4",
					children: /* @__PURE__ */ _jsx("path", {
						className: "cls-3",
						transform: "translate(-125.97 -50.62)",
						d: "m128.28 74.36s-1.73-22.3 19.25-22.3 19 22.3 19 22.3"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-5",
					transform: "translate(-125.97 -50.62)",
					d: "M140.28,65.3a4.39,4.39,0,0,0-.19-1.62c-.45-3.15,1.52-4.42,4-5.45.91,3.3.56,4.24-2.25,6.13A6.86,6.86,0,0,1,140.28,65.3Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-5",
					transform: "translate(-125.97 -50.62)",
					d: "M147.27,74.19a11.26,11.26,0,0,0,.7-4.82,4.53,4.53,0,0,0-6.86-3.86l-.74.32h0l-.58-.12c-3.2-1.84-6.11-.36-7.15,2.18-.92,2.25-.28,4.29.58,6.28Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-5",
					transform: "translate(-125.97 -50.62)",
					d: "M162.28,74.22l-.67-1.87c0,.11,0,.22-.07.32A2.93,2.93,0,0,1,160,74.21Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-5",
					transform: "translate(-125.97 -50.62)",
					d: "m152.61 74.2h6.39l0.77-2.24 0.95-2.21-1-2.74a3.53 3.53 0 0 1 -0.14 0.61 3.17 3.17 0 0 1 -2.47 1.86h-0.1a0.07 0.07 0 0 1 -0.08 -0.05l0.86-2.48 1-2.41-0.84-2.54c0 0.1 0 0.2-0.07 0.29a3.17 3.17 0 0 1 -2.47 1.86h-0.1a0.07 0.07 0 0 1 -0.08 -0.05l0.86-2.48 0.93-2.16a4.56 4.56 0 0 0 -5.75 -2.62 4.57 4.57 0 0 0 -2.77 5.82z"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgProvisioning);
export { ForwardRef as ReactComponent };
